module.exports = __webpack_public_path__ + "img/number-black-27.7f38b12f.png";